import {connect} from "react-redux";
import DealerLeadActivityList from "./list";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../../service/Activity/action";
import {
    userCheckoutDealerLead,
    markAttendancesDealerLead,
    addTaggedAlong,
    getActivityFilter,
    ratingSave
} from "../../../../../service/Dealer/action";
import {errorLogs} from "../../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    isCheckoutDetails: state.Dealer.isCheckoutDetails,
    markAttendanceDetails: state.Dealer.markAttendance,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    activityFilter: state.Dealer.activityFilter,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            userCheckoutDealerLead,
            markAttendancesDealerLead,
            addTaggedAlong,
            getActivityFilter,
            ratingSave,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DealerLeadActivityList);
